import _regeneratorRuntime from "/client/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/client/node_modules/@babel/runtime/helpers/esm/createClass";
import { LogLevel } from "@logtail/types";
import { makeBatch, makeThrottle } from "@logtail/tools"; // Set default options for Logtail

var defaultOptions = {
  // Default sync endpoint (protocol + domain)
  endpoint: "https://in.logtail.com",
  // Maximum number of logs to sync in a single request to Logtail.com
  batchSize: 1000,
  // Max interval (in milliseconds) before a batch of logs proceeds to syncing
  batchInterval: 1000,
  // Maximum number of sync requests to make concurrently
  syncMax: 5,
  // If true, errors/failed logs should be ignored
  ignoreExceptions: true,
  // maximum depth (number of attribute levels) of a context object
  contextObjectMaxDepth: 50,
  // produce a warn log when context object max depth is reached
  contextObjectMaxDepthWarn: true
};
/**
 * Logtail core class for logging to the Logtail.com service
 */

var Logtail =
/*#__PURE__*/
function () {
  /* CONSTRUCTOR */

  /**
   * Initializes a new Logtail instance
   *
   * @param sourceToken: string - Private source token for logging to Logtail.com
   * @param options?: ILogtailOptions - Optionally specify Logtail options
   */
  function Logtail(sourceToken, options) {
    var _this = this;

    _classCallCheck(this, Logtail);

    // Middleware
    this._middleware = []; // Number of logs logged

    this._countLogged = 0; // Number of logs successfully synced with Logtail

    this._countSynced = 0; // First, check we have a valid source token

    if (typeof sourceToken !== "string" || sourceToken === "") {
      throw new Error("Logtail source token missing");
    } // Store the source token, to use for syncing with Logtail.com


    this._sourceToken = sourceToken; // Merge default and user options

    this._options = Object.assign(Object.assign({}, defaultOptions), options); // Create a throttler, for sync operations

    var throttle = makeThrottle(this._options.syncMax); // Sync after throttling

    var throttler = throttle(function (logs) {
      return _this._sync(logs);
    }); // Create a batcher, for aggregating logs by buffer size/interval

    var batcher = makeBatch(this._options.batchSize, this._options.batchInterval);
    this._batch = batcher(function (logs) {
      return throttler(logs);
    });
  }
  /* PRIVATE METHODS */


  _createClass(Logtail, [{
    key: "getContextFromError",
    value: function getContextFromError(e) {
      return {
        stack: e.stack
      };
    }
    /* PUBLIC METHODS */

    /**
     * Number of entries logged
     *
     * @returns number
     */

  }, {
    key: "log",

    /**
     * Log an entry, to be synced with Logtail.com
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */
    value: function () {
      var _log = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(message) {
        var level,
            context,
            log,
            transformedLog,
            _iteratorNormalCompletion,
            _didIteratorError,
            _iteratorError,
            _iterator,
            _step,
            middleware,
            newTransformedLog,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                level = _args.length > 1 && _args[1] !== undefined ? _args[1] : LogLevel.Info;
                context = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

                if (!(typeof this._sync !== "function")) {
                  _context.next = 4;
                  break;
                }

                throw new Error("No Logtail logger sync function provided");

              case 4:
                // Increment log count
                this._countLogged++; // Start building the log message

                log = Object.assign({
                  // Implicit date timestamp
                  dt: new Date(),
                  // Explicit level
                  level: level
                }, context); // Determine the type of message...
                // Is this an error?

                if (message instanceof Error) {
                  log = Object.assign(Object.assign(Object.assign({}, log), this.getContextFromError(message)), {
                    // Add error message
                    message: message.message
                  });
                } else {
                  log = Object.assign(Object.assign({}, log), {
                    // Add string message
                    message: message
                  });
                }

                transformedLog = log;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 11;
                _iterator = this._middleware[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 24;
                  break;
                }

                middleware = _step.value;
                _context.next = 17;
                return middleware(transformedLog);

              case 17:
                newTransformedLog = _context.sent;

                if (!(newTransformedLog == null)) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return", transformedLog);

              case 20:
                transformedLog = newTransformedLog;

              case 21:
                _iteratorNormalCompletion = true;
                _context.next = 13;
                break;

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](11);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 30:
                _context.prev = 30;
                _context.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 33:
                _context.prev = 33;

                if (!_didIteratorError) {
                  _context.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context.finish(33);

              case 37:
                return _context.finish(30);

              case 38:
                _context.prev = 38;
                _context.next = 41;
                return this._batch(transformedLog);

              case 41:
                // Increment sync count
                this._countSynced++;
                _context.next = 51;
                break;

              case 44:
                _context.prev = 44;
                _context.t1 = _context["catch"](38);

                if (this._options.ignoreExceptions) {
                  _context.next = 50;
                  break;
                }

                throw _context.t1;

              case 50:
                console.error(_context.t1);

              case 51:
                return _context.abrupt("return", transformedLog);

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[11, 26, 30, 38], [31,, 33, 37], [38, 44]]);
      }));

      function log(_x) {
        return _log.apply(this, arguments);
      }

      return log;
    }()
    /**
     *
     * Debug level log, to be synced with Logtail.com
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "debug",
    value: function () {
      var _debug = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(message) {
        var context,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                return _context2.abrupt("return", this.log(message, LogLevel.Debug, context));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function debug(_x2) {
        return _debug.apply(this, arguments);
      }

      return debug;
    }()
    /**
     *
     * Info level log, to be synced with Logtail.com
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "info",
    value: function () {
      var _info = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(message) {
        var context,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                return _context3.abrupt("return", this.log(message, LogLevel.Info, context));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function info(_x3) {
        return _info.apply(this, arguments);
      }

      return info;
    }()
    /**
     *
     * Warning level log, to be synced with Logtail.com
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "warn",
    value: function () {
      var _warn = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(message) {
        var context,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                context = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                return _context4.abrupt("return", this.log(message, LogLevel.Warn, context));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function warn(_x4) {
        return _warn.apply(this, arguments);
      }

      return warn;
    }()
    /**
     *
     * Warning level log, to be synced with Logtail.com
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */

  }, {
    key: "error",
    value: function () {
      var _error = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(message) {
        var context,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                context = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                return _context5.abrupt("return", this.log(message, LogLevel.Error, context));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function error(_x5) {
        return _error.apply(this, arguments);
      }

      return error;
    }()
    /**
     * Sets the sync method - i.e. the final step in the pipeline to get logs
     * over to Logtail.com
     *
     * @param fn - Pipeline function to use as sync method
     */

  }, {
    key: "setSync",
    value: function setSync(fn) {
      this._sync = fn;
    }
    /**
     * Add a middleware function to the logging pipeline
     *
     * @param fn - Function to add to the log pipeline
     * @returns void
     */

  }, {
    key: "use",
    value: function use(fn) {
      this._middleware.push(fn);
    }
    /**
     * Remove a function from the pipeline
     *
     * @param fn - Pipeline function
     * @returns void
     */

  }, {
    key: "remove",
    value: function remove(fn) {
      this._middleware = this._middleware.filter(function (p) {
        return p !== fn;
      });
    }
  }, {
    key: "logged",
    get: function get() {
      return this._countLogged;
    }
    /**
     * Number of log entries synced with Logtail.com
     *
     * @returns number
     */

  }, {
    key: "synced",
    get: function get() {
      return this._countSynced;
    }
  }]);

  return Logtail;
}(); // noinspection JSUnusedGlobalSymbols


export default Logtail;